import { put, call, takeLatest, takeEvery, fork, all, select} from "redux-saga/effects";
import { searchForAllProviders, searchForAllProvidersByLocationAndDistance, searchForAllProvidersByName, getProviderDetail,
    getProvidersListByVisitType,getMyDoctorDirectVideoVisitSchedules, getProviderWithEarliestSchedule, searchForGenericProvider } from "../api/providerApi";
import * as types from "../constants/actionTypes";
import { log, logAPI } from "../api/andyliticsApi";

export default function* searchProvidersSaga() {
    yield takeLatest(types.SEARCH_PROVIDER, handleSearch);
    yield takeLatest(types.SEARCH_PROVIDER_BY_LOCAION, handleLocationSearch);
    yield takeLatest(types.SEARCH_PROVIDER_BY_NAME, handleNameSearch);
    yield takeLatest(types.PROVIDER_DETAIL, handleProviderDetail);
    yield takeLatest(types.GET_PROVIDERS_LIST_BY_VISITTYPE, handleProvidersListByVisitType);
    yield takeLatest(types.GET_PROVIDER_WITH_EARLIESTSCHEDULE, handleProviderEarliestSchedule);
    yield takeLatest(types.SEARCH_FOR_GENERIC_PROVIDER, handleGenericProviderSearch);
    yield takeLatest(types.SEARCH_FOR_GENERIC_PROVIDER_SLOT_AVAILABILITY, handleGenericProviderSearchForSlotAvailability);
    yield takeLatest (types.GET_PROVIDERS_LIST_VISITTYPE, handleProvidersListVisitType)

}


export function* handleSearch(payload) {
    const start = new Date();
    try {
        const providers = yield call(searchForAllProviders, payload.searchModel, payload.isLatestCall);
        yield all([
            put({ type: types.SAVE_PROVIDER_SEARCH_MODEL, payload }),
            put({ type: types.LOAD_PROVIDERS_SUCCESS, providers })
        ]);

        logAPI("MBHWeb.Saga.Provider.SearchAll", start, null);

        //debugger;
        if (payload.callback) {
            payload.callback(providers);
        }
    }
    catch (error) {
        console.error(error);
        logAPI("MBHWeb.Saga.Provider.SearchAll.Failure", start, null, error);
        yield all([
            put({ type: types.AJAX_CALL_ERROR, error }),
            put({ type: types.SEARCH_PROVIDER_ERROR })
        ]);
        if (payload.callback) {
            payload.callback(null);
        }
    }
}

export function* handleLocationSearch(payload) {
    const start = new Date();
    try {
        const providers = yield call(searchForAllProvidersByLocationAndDistance, payload);
        //const updateFacets = payload.updateFacets;

        yield all([
            //put({ type: types.UPDATE_FACETS, updateFacets }),
            put({ type: types.LOAD_PROVIDERS_SUCCESS, providers })
        ]);
        logAPI("MBHWeb.Saga.Provider.SearchAll", start, null);
    }
    catch (error) {
        console.error(error);
        logAPI("MBHWeb.Saga.Provider.SearchAll.Failure", start, null, error);
        yield put({ type: types.AJAX_CALL_ERROR, error });
    }
}


export function* handleNameSearch(payload) {
    const start = new Date();
    try {
        const providers = yield call(searchForAllProvidersByName, payload);

        yield all([
            put({ type: types.LOAD_PROVIDERS_SUCCESS, providers })
        ]);
        logAPI("MBHWeb.Saga.Provider.SearchName", start, null);
    }
    catch (error) {
        console.error(error);
        logAPI("MBHWeb.Saga.Provider.SearchName.Failure", start, null, error);
        yield put({ type: types.AJAX_CALL_ERROR, error });
    }
}

export function* handleProviderDetail(payload) {
    const start = new Date();
    try {
        const providers = yield call(getProviderDetail, payload.searchModel);

        yield all([
            put({ type: types.LOAD_PROVIDER_DETAIL_SUCCESS, providers })
        ]);
        logAPI("MBHWeb.Saga.Provider.Detail", start, null);
    }
    catch (error) {
        console.error(error);
        logAPI("MBHWeb.Saga.Provider.Detail.Failure", start, null, error);
        yield put({ type: types.AJAX_CALL_ERROR, error });
    }
}

export function* handleProvidersListVisitType(payload) {
    const start = new Date();
    try {
        const providers = yield call(getProvidersListByVisitType, payload.searchModel, payload.token);        

        yield all([
            put({ type: types.GET_PROVIDERS_LIST_VISITTYPE_SUCCESS, providers })
        ]);

        logAPI("MBHWeb.Saga.Provider.ProvidersListVisitType", start, null);

    }
    catch (error) {
        console.error(error);
        logAPI("MBHWeb.Saga.Provider.ProvidersListVisitType.Failure", start, null, error);
        yield all([
            put({ type: types.AJAX_CALL_ERROR, error }),
        ]);       
    }
}

export function* handleProvidersListByVisitType(payload) {
    const start = new Date();
    try {
        let searchProviderModel = {
            proxyPatientId: payload.searchModel.proxyPatientId,
            loginId: payload.searchModel.loginId
        };

        let providerList = yield call(getMyDoctorDirectVideoVisitSchedules, searchProviderModel, payload.token,payload.enableNewVideoVisitFlow);
        const providerSlots = providerList && providerList.scheduleDays && providerList.scheduleDays.length > 0 ?
                                        providerList.scheduleDays[0] : null;

         const providers = providerList && providerList.provider ? providerList.provider : null;
        if (providerSlots && providers) {
            //const currentProvId = providerSlots.provider && providerSlots.provider.id ? providerSlots.provider.id : null;
            const providerInfo = providers ? providers : null;
           // const providerInfo = providers.length > 0 ? providers.find((v, i) => { return v.epicId === currentProvId }) : null;
             providerList.providerInfo = providerInfo;
         }
        yield all([
            put({ type: types.GET_PROVIDER_WITH_EARLIESTSCHEDULE_SUCCESS, providers: providerList })
        ]);

        logAPI("MBHWeb.Saga.ProvidersList.VisitType", start, null);

    }
    catch (error) {
        console.error(error);
        logAPI("MBHWeb.Saga.ProvidersList.VisitType.Failure", start, null, error);
        yield all([
            put({ type: types.AJAX_CALL_ERROR, error }),
            put({ type: types.GET_PROVIDER_WITH_EARLIESTSCHEDULE_ERROR })
        ]);
    }
}

export function* handleProviderEarliestSchedule(payload) {
    const start = new Date();
    try {
        const providers = yield call(getProviderWithEarliestSchedule, payload.searchModel);        

        yield all([
            put({ type: types.GET_PROVIDER_WITH_EARLIESTSCHEDULE_SUCCESS, providers })
        ]);

        logAPI("MBHWeb.Saga.Provider.EarliestSchedule", start, null);

    }
    catch (error) {
        console.error(error);
        logAPI("MBHWeb.Saga.Provider.EarliestSchedule.Failure", start, null, error);
        yield all([
            put({ type: types.AJAX_CALL_ERROR, error }),
            put({ type: types.GET_PROVIDER_WITH_EARLIESTSCHEDULE_ERROR })
        ]);       
    }
}

export function* handleGenericProviderSearch(payload) {
    const start = new Date();
    try {
        const domainData = yield select((state) => state.domain);
        const { location, radius, sortBy, visitTypeId, page, perPage, startDate, endDate } = payload.searchModel;
        const providers = yield call(searchForGenericProvider, domainData.t, location, radius, sortBy, visitTypeId, page, perPage, startDate, endDate);
        yield put({ type: types.SEARCH_FOR_GENERIC_PROVIDER_SUCCESS, providers });
        logAPI("MBHWeb.Saga.Provider.SearchForGenericProvider.Success", start, null);
        if (payload.callback) {
            payload.callback(providers);
        }
    }
    catch (error) {
        console.error(error);
        logAPI("MBHWeb.Saga.Provider.SearchForGenericProvider.Failure", start, null, error);
        yield put({ type: types.SEARCH_FOR_GENERIC_PROVIDER_FAILURE, error });
    }
}

export function* handleGenericProviderSearchForSlotAvailability(payload) {
    const start = new Date();
    try {
        const domainData = yield select((state) => state.domain);
        const { location, radius, sortBy, visitTypeId, page, perPage, startDate, endDate } = payload.searchModel;
        const providers = yield call(searchForGenericProvider, domainData.t, location, radius, sortBy, visitTypeId, page, perPage, startDate, endDate);
        yield put({ type: types.SEARCH_FOR_GENERIC_PROVIDER_SLOT_AVAILABILITY_SUCCESS, providers });
        logAPI("MBHWeb.Saga.Provider.SearchForGenericProvider.SlotAvailability.Success", start, null);
        if (payload.callback) {
            payload.callback(providers);
        }
    }
    catch (error) {
        console.error(error);
        logAPI("MBHWeb.Saga.Provider.SearchForGenericProvider.SlotAvailability.Failure", start, null, error);
        yield put({ type: types.SEARCH_FOR_GENERIC_PROVIDER_SLOT_AVAILABILITY_FAILURE, error });
    }
}
